import React, { forwardRef } from "react";

const CompassSvg = forwardRef(function CompassSvg(
  { size = 24, className, children, ...props },
  ref
) {
  return (
    <svg
      ref={ref}
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      {...props}
    >
      {children}
    </svg>
  );
});

/** A quieter compass with a single, simplified interior diamond. */
export const CompassLogoSimplified = forwardRef(function CompassLogoSimplified(
  props,
  ref
) {
  return (
    <CompassSvg ref={ref} {...props}>
      <circle cx="12" cy="12" r="10" />
      <path d="m16 8-2.5 5.5L8 16l2.5-5.5L16 8Z" />
    </CompassSvg>
  );
});

/** A filled northeast point gives the mark a clear forward direction. */
export const CompassLogoDirectional = forwardRef(function CompassLogoDirectional(
  props,
  ref
) {
  return (
    <CompassSvg ref={ref} {...props}>
      <circle cx="12" cy="12" r="10" />
      <path d="m17 7-3.1 7.1L12 12.2 17 7Z" fill="currentColor" stroke="none" />
      <path d="m12 12.2-5 4.8 6.9-2.9" />
    </CompassSvg>
  );
});

/** The opening at the east edge turns the outer ring into a subtle C. */
export const CompassLogoC = forwardRef(function CompassLogoC(props, ref) {
  return (
    <CompassSvg ref={ref} {...props}>
      <path d="M18.8 5.2A9.6 9.6 0 1 0 18.8 18.8" />
      <path d="m16 8-2.5 5.5L8 16l2.5-5.5L16 8Z" />
    </CompassSvg>
  );
});

/** Lucide-style ring paired with a compact solid directional pointer. */
export const CompassLogoHybrid = forwardRef(function CompassLogoHybrid(props, ref) {
  return (
    <CompassSvg ref={ref} {...props}>
      <circle cx="12" cy="12" r="10" />
      <path d="m17 7-3.2 7.2L7 17l3.2-7.2L17 7Z" fill="currentColor" stroke="none" />
      <circle cx="12" cy="12" r="1.15" fill="currentColor" stroke="none" />
    </CompassSvg>
  );
});

/** Open C-shaped ring paired with the hybrid's solid directional pointer. */
export const CompassLogoCHybrid = forwardRef(function CompassLogoCHybrid(props, ref) {
  return (
    <CompassSvg ref={ref} {...props}>
      <path d="M20.31 7.2A9.6 9.6 0 1 0 20.31 16.8" />
      <path
        d="M17 6.5 13.8 14.2 7 17.5 10.2 9.8 17 6.5ZM12 10.85a1.15 1.15 0 1 0 0 2.3 1.15 1.15 0 1 0 0-2.3Z"
        fill="currentColor"
        fillRule="evenodd"
        clipRule="evenodd"
        stroke="none"
      />
    </CompassSvg>
  );
});

// The selected product mark is the C-shaped ring with the solid needle.
const CompassLogo = CompassLogoCHybrid;

export default CompassLogo;
